<template>
  <div class="slider-wrapper">
    <div v-if="props.category" class="category">
      {{ props.category }}
    </div>
    <template v-if="slides.length && slides.length > 0">
      <swiper
        :slides-per-view="1"
        :space-between="0"
        :modules="[Navigation, Pagination, Autoplay]"
        loop
        :threshold="swipeThreshold"
        :initial-slide="0"
        :autoplay="{
          delay: 5000,
          disableOnInteraction: false,
        }"
        navigation
        :pagination="{
          clickable: true,
          type: 'custom',
          renderCustom: (swiper, current, total) =>
            `<div class='swiper-custom-pagination'>${current} ${$t(
              'global.of'
            )} ${total}</div>`,
        }"
      >
        <swiper-slide
          v-for="(product, key) in props.slides"
          :key="key"
          class="swiper-item"
        >
          <ProductItem
            :product="product"
            single
            v-bind="{
              affordable: settings?.affordable ? settings.affordable : null,
            }"
          />
        </swiper-slide>
      </swiper>
    </template>
    <template v-else>
      <ProductItem
        :empty="true"
        link="/shop"
        :product="null"
        single
      ></ProductItem>
    </template>
  </div>
</template>

<script setup>
import { Navigation, Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
import ProductItem from "@/components/Shop/ProductListItem.vue";
import "swiper/swiper-bundle.css";
import { defineProps } from "vue";
const props = defineProps({
  slides: Object,
  category: String,
  settings: Object,
});

// Default Swiper threshold is 0, so the first click changes the slide instead of opening the product.
const swipeThreshold = 10;
</script>

<style lang="scss" scoped src="@/styles/ProductSlider.scss"></style>
